import styled from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { boxPropExclusions } from '../Box/props.js';

var wrapper = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-1g8x07m-0"
})(["display:flex;input[type='number']{-moz-appearance:textfield;}input[type='number']::-webkit-outer-spin-button,input[type='number']::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}", ""], boxStyles);

export { wrapper };
